import { debounce } from 'radash';

const TALKING_INDICATOR_MUTE_INTERVAL = 500;

export const muteUser = debounce(
  { delay: TALKING_INDICATOR_MUTE_INTERVAL },
  (
    id: string,
    muted: boolean | undefined,
    isBreakout: boolean,
    isModerator: boolean,
    toggleVoice: (userId: string, muted: boolean) => void,
  ) => {
    if (!isModerator || isBreakout || muted) return null;
    toggleVoice(id, true);
    return null;
  },
);

/**
 * ✅ Converts + in a string to spaces
 * Returns original string if no + found
 */
export function normalizePlusString(str: string): string {
  if (typeof str !== 'string') return '';
  return str.includes('+') ? str.replace(/\+/g, ' ').trim() : str;
}


export default {
  muteUser,
  normalizePlusString
};
